import { useDateNow, useReduxState } from 'hooks';
import { Badge } from 'components/common';

import type {
  AchievementProgress,
  CalendarEventProgress,
  CourseProgress
} from 'shared-types';
import type { BadgeCategory } from 'components/common/Badge';

type Props =
  | {
      progressData?: AchievementProgress;
      startDate?: never;
      type: 'achievement';
    }
  | {
      progressData?: CourseProgress;
      startDate?: never;
      type: 'course';
    }
  | {
      progressData?: CalendarEventProgress;
      startDate: string;
      type: 'event';
    };

const PathStepTileItemStatus = ({ progressData, startDate, type }: Props) => {
  const { dateNow } = useDateNow();

  const { messages } = useReduxState();

  let category = 'default';
  let icon = null;
  let tooltip = null;

  if (type === 'achievement') {
    const achievementProgress = progressData as AchievementProgress;
    if (achievementProgress?.status === 'completed') {
      category = 'success-light';
      icon = 'check';
      tooltip = messages.commonCompleted;
    } else if (achievementProgress) {
      icon = 'hourglass-start';
      tooltip = messages.commonInProgress;
    }
  } else if (type === 'course') {
    const courseProgress = progressData as CourseProgress;
    if (courseProgress?.completion?.status === 'success') {
      category = 'success-light';
      icon = 'check';
      tooltip = messages.commonCompleted;
    } else if (
      courseProgress?.readingProgress ||
      courseProgress?.videoProgress ||
      courseProgress?.taskAnswers
    ) {
      icon = 'hourglass-start';
      tooltip = messages.commonInProgress;
    }
  } else if (type === 'event') {
    const eventProgress = progressData as CalendarEventProgress;
    if (eventProgress?.completionDate) {
      category = 'success-light';
      icon = 'check';
      tooltip = messages.eventCalendarParticipantParticipated;
    } else if (eventProgress && startDate && Date.parse(startDate) < dateNow) {
      icon = 'hourglass-start';
      tooltip = messages.commonInProgress;
    }
  }

  return (
    <div className="status">
      {icon && tooltip ? (
        <Badge
          category={category as BadgeCategory}
          icon={icon}
          style={{
            borderRadius: 24,
            justifyContent: 'center',
            paddingLeft: 0,
            paddingRight: 0,
            height: 24,
            width: 24
          }}
          tooltip={tooltip}
        />
      ) : null}
    </div>
  );
};

export default PathStepTileItemStatus;
